import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import  Home from '../Components/Home/Home'
import Passbok from "../Components/passbook/Passbok";
import SchemesPage from "../Components/passbook/SchemesPage";
import About from "../Components/About/About";
import Contact from "../Components/Contact/Contact";
import Login from "../Components/Auth/Login";
import Register from "../Components/Auth/Register";
import Profile from "../Components/Profile/Profile";
import PrivacyPolicy from "../Components/policy/PrivacyPolicy";
import TermsCondition from "../Components/policy/TermsCondition";
import RefundPolicy from "../Components/policy/RefundPolicy";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import CommonLoader from "../Components/CommonLoader";
import PdfRedirect from "../Components/PdfRedirect";
import SEO from "../Components/SEO";

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return children;
};

const AppRoutes = () => {
    const auth = getAuth();
    const [uid, setUid] = useState(() => auth.currentUser?.uid || null);
    const [authLoading, setAuthLoading] = useState(() => !auth.currentUser);

    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          setUid(user.uid);
        } else {
          setUid(null);
        }
        setAuthLoading(false);
      });
      return () => unsubscribe();
    }, [auth]);

    if (authLoading) {
      return <CommonLoader />;
    }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ScrollToTop>
            <SEO
              title="Home"
              description="Explore luxury gold jewelry, diamonds, and precious gemstone collections at Chirayil Gold and Diamonds."
              keywords="gold jewelry, diamonds, luxury jewelry, Chirayil Gold, Kerala jewelry"
              canonical="/"
            />
            <Home />
          </ScrollToTop>
        }
      />
      <Route
        path="/schemes"
        element={
          <ScrollToTop>
            <SEO
              title="Gold Savings Schemes"
              description="Join Chirayil Gold & Diamonds monthly gold savings scheme. Flexible plans, exciting benefits, and easy online payments."
              keywords="gold savings scheme, monthly gold plan, Chirayil schemes, buy gold online"
              canonical="/schemes"
            />
            <SchemesPage />
          </ScrollToTop>
        }
      />
      {uid && (
        <>
          <Route
            path="/passbook"
            element={
              <ScrollToTop>
                <SEO title="My Gold Passbook" description="View your scheme transactions, passbook summary, and installment history." canonical="/passbook" />
                <Passbok />
              </ScrollToTop>
            }
          />{" "}
          <Route
            path="/register"
            element={
              <ScrollToTop>
                <SEO title="Scheme Registration" description="Register for a new Chirayil Gold savings scheme online." canonical="/register" />
                <Register />
              </ScrollToTop>
            }
          />
          <Route
            path="/profile"
            element={
              <ScrollToTop>
                <SEO title="User Profile" description="Manage your personal account details and address." canonical="/profile" />
                <Profile />
              </ScrollToTop>
            }
          />
        </>
      )}
      <Route
        path="/about"
        element={
          <ScrollToTop>
            <SEO
              title="About Us"
              description="Learn about the heritage, values, and fine jewelry craftsmanship of Chirayil Gold and Diamonds."
              keywords="about Chirayil Gold, heritage jewelry, trusted jeweler"
              canonical="/about"
            />
            <About />
          </ScrollToTop>
        }
      />
      <Route
        path="/contact"
        element={
          <ScrollToTop>
            <SEO
              title="Contact Us"
              description="Get in touch with Chirayil Gold and Diamonds. Find showroom location, customer support, and contact details."
              keywords="contact Chirayil Gold, customer care, showroom address"
              canonical="/contact"
            />
            <Contact />
          </ScrollToTop>
        }
      />
      <Route
        path="/login"
        element={
          <ScrollToTop>
            <SEO
              title="Customer Login"
              description="Sign in to your Chirayil Gold and Diamonds account to manage schemes and view passbooks."
              canonical="/login"
            />
            <Login />
          </ScrollToTop>
        }
      />

      <Route
        path="/privacy-policy"
        element={
          <ScrollToTop>
            <SEO
              title="Privacy Policy"
              description="Read the Privacy Policy of Chirayil Gold and Diamonds regarding user data privacy and security."
              canonical="/privacy-policy"
            />
            <PrivacyPolicy />
          </ScrollToTop>
        }
      />
      <Route
        path="/terms-and-conditions"
        element={
          <ScrollToTop>
            <SEO
              title="Terms and Conditions"
              description="Terms and conditions for using Chirayil Gold and Diamonds services and online gold schemes."
              canonical="/terms-and-conditions"
            />
            <TermsCondition />
          </ScrollToTop>
        }
      />
      <Route
        path="/refund-policy"
        element={
          <ScrollToTop>
            <SEO
              title="Refund Policy"
              description="Understand the refund and cancellation policy of Chirayil Gold and Diamonds."
              canonical="/refund-policy"
            />
            <RefundPolicy />
          </ScrollToTop>
        }
      />
      <Route
        path="/:id"
        element={
          <ScrollToTop>
            <PdfRedirect />
          </ScrollToTop>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
